<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Add Property to Group'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <form [formGroup]="form">
    <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">

      @if (loaded) {
        <tidy-card>
          <tidy-row class="field-top-padding field-bottom-padding">
            <tidy-select
              [icon]="'assets/svg/people-circle-outline.svg'"
              [label]="'Group'"
              [items]="teamItems"
              [form]="form.controls.team"
              formControlName="team"
              [submitted]="submitted"
              [errorMessage]="'Please select a group'" />
          </tidy-row>
          <tidy-row>
            <tidy-select
              [icon]="'assets/svg/location-outline.svg'"
              [label]="'Add to Property'"
              [items]="propertyItems"
              [form]="form.controls.property"
              formControlName="property"
              [submitted]="submitted"
              [errorMessage]="'Please select a property'" />
          </tidy-row>
        </tidy-card>
        <tidy-button
          [text]="'Add Property to Group'"
          [action]="boundAddPropertyToTeam"
          class="primary" />
      }
    </tidy-wrapper>
  </form>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
